const awayMessage = `Assorted boxes are not available at the moment. Please DM or email us to place orders for batches and catering!`

export default awayMessage